import { render, staticRenderFns } from "./TrixWrapper.vue?vue&type=template&id=bcdc4c84&"
import script from "./TrixWrapper.vue?vue&type=script&lang=js&"
export * from "./TrixWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TrixWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports